import api from ".";

export const getTags = () => api.get("/tags");

export const deleteTag = ({ uuid }) => api.delete(`/tags/${uuid}`);

export const createTag = (data) => api.post("/tags", data);

export const getEntities = (params) => api.get("/entities", { params });

export const createEntity = (data) => api.post("/entities", data);

export const editEntity = ({ uuid, ...data }) => api.patch(`/entities/${uuid}`, data);

export const getRoles = (params) => api.get("/roles", { params });

export const createRole = (data) => api.post("/roles", data);

export const updateRole = ({ uuid, ...data }) => api.patch(`/roles/${uuid}`, data);

export const deleteRole = ({ uuid }) => api.delete(`/roles/${uuid}`);

export const addStaff = (data) => api.post("/users/add-member", data);

export const getStaff =
	(type = "active") =>
	(params) =>
		api.get(`/users/${type}-accounts`, { params });

export const updateStaffStatus =
	(type = "active") =>
	({ uuid }) =>
		api.patch(`/users/${uuid}/${type === "active" ? "disable" : "enable"}-account`);

export const assignStaffRoleAndEntity = (data) => api.post("/users/assign-role", data);

export const updateProfile = ({ uuid, ...data }) => api.post(`/users/${uuid}/update`, data, { headers: { "Content-Type": "multipart/form-data" } });

export const updatePassword = (data) => api.patch("/users/change-password", data);

export const getNotifications = () => api.get("/notification-settings");

export const updateNotifications = (data) => api.patch("/notification-settings", data);

export const getTiers = () => api.get("/tiers");

export const getBusinessTier = () => api.get("/tiers/user-business");

export const getSettings = (params) => api.get("/settings", { params });

export const updateSettings = (values) => api.patch("/settings", values);

export const updateCustomizations = (values) => api.patch("/settings/customized-label", values);

export const verifyBVN = (params) => api.get("/users/verify-bvn", { params });
